// employees/EmployeeContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getAllResignationsApi} from "api/services/resignations"
import { useSearchParams } from 'react-router-dom';
import useResignationFilter from "../hooks/filterHook"
import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"
import { useMediaQuery } from "react-responsive";

							
									  

// Create the Resignation context
const resignationContext = createContext();

// Custom hook for accessing Resignation context easily
export const useResignation = () => {
  return useContext(resignationContext); 
};

// ResignationProvider component to wrap around components needing access to Resume data
export const ResignationProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const [resignationModal, setResignationModal] = useState(false);
  const [ selectedResignation, setSelectedResignation] = useState(false);
  const [resignationData, setResignationData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",
    department: searchParams.get("department") || "",
    gender: searchParams.get("gender") || "",
    status: searchParams.get("status") || ""
    
})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange, handleClearAll,
    isFilterDirty, setIsFilterDirty} = useResignationFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
    let _filters = [...filters].filter(item=> item.value)
    const filter_params = _filters.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
        }, {});
    return filter_params
        
})

const setResignationParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}



    const getResignationList = () => {
        setLoading(true)
        setFilterLoading(true)      
        let filter_params = getFilterParams()
          if(filter_params?.issue_date_after){
            filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.issue_date_before){
          filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
         }

        if(filter_params?.expiry_date_after){
            filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.expiry_date_before){
            filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
        }


          
        getAllResignationsApi({         
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          // department / gender / status come from filter_params only. The
          // pageSettings copies are the URL values at first load and never
          // change, so sending them here re-applied a filter the user had
          // already cleared (e.g. picking "All" after opening ?status=pending).
          user: pageSettings?.userData,
          ...filter_params    
        }).then(response=>{
          console.log(response.data.results, "resultsss---->>>")
          if(view=="grid" && pageSettings?.page!==1){
            setResignationData([...resignationData,...response.data.results]);

          }else{
            setResignationData(response.data.results);

          }
          // setResignationData(response.data.results);
          setPageSettings((prev) => ({
            ...prev,
            total: response.data.count
          }))
    
          setLoading(false)
          setFilterLoading(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    getResignationList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  useEffect(()=>{
    setResignationParams(pageSettings)
  },[pageSettings])

  const handleApplyFilter = () => {
    setShowFilterDrawer(false)
    setIsFilterDirty(false)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })

  }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }



  const handleResignationDetailPage = (id, index) => {			  
   // navigate(`/resignations/${id}`)
   
    setSelectedPage(index)
    setResignationModal(true)
  }



  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    resignationData, setResignationData,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    resignationModal, setResignationModal,
    selectedResignation, setSelectedResignation,

    handleGridChange,
    handleChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleResignationDetailPage,
    handleDateChange,
    handleClearAll,
    getResignationList,
    isFilterDirty

  }), [resignationData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, resignationModal, selectedResignation, isFilterDirty]);

  return (
    <resignationContext.Provider value={value}>
      {children}
    </resignationContext.Provider>
  );
};